/**
 * Constantes d'infrastructure de l'hébergement email (serveur Stalwart managé).
 *
 * Ces valeurs pointent vers l'infra mail générique `*.propelsia.ai` : elles sont
 * STABLES et ne changent pas par déploiement — donc des constantes, pas des
 * variables d'env. Source unique partagée entre le backend (réglages de connexion
 * renvoyés au client mail + templates DNS MX/SPF/DMARC) et la doc utilisateur
 * (feature-manifest `website.email.configure`).
 *
 * Seuls les secrets d'accès à l'API de management (`STALWART_MGMT_URL` /
 * `STALWART_MGMT_TOKEN`) restent en variables d'env côté backend.
 */
export const MAIL_HOSTING = {
  /** Serveur entrant — IMAP over SSL/TLS. */
  IMAP_HOST: 'imap.propelsia.ai',
  IMAP_PORT: 993,
  /** Serveur sortant — SMTP submission over implicit TLS (SSL). Stalwart n'expose PAS
   * le 587/STARTTLS (connexion refusée) : soumission uniquement en 465 (reco RFC 8314). */
  SMTP_HOST: 'smtp.propelsia.ai',
  SMTP_PORT: 465,
  /** Cible des enregistrements MX écrits dans la zone du client. */
  MX_HOST: 'mx.propelsia.ai',
  /** Domaine inclus dans le SPF de la zone client (`include:`). */
  SPF_INCLUDE: '_spf.propelsia.ai',
  /** Adresse d'agrégation des rapports DMARC (`rua=`). */
  DMARC_RUA: 'mailto:dmarc@propelsia.ai',
} as const;
